module.exports = __webpack_public_path__ + "static/media/edit.04266e33.svg";